import useCountdown from '@/hooks/useCountdown'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

interface DateTimeDisplayProps {
  value?: string
  type?: string
}

const DateTimeDisplay: React.FC<DateTimeDisplayProps> = ({ value, type }) => {
  return (
    <span>
      {value}
      {type}
    </span>
  )
}

DateTimeDisplay.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
}

DateTimeDisplay.defaultProps = {
  value: '',
  type: '',
}

interface ShowCounterProps {
  days?: number
  hours?: number
  minutes?: number
  seconds?: number
}

const ShowCounter: React.FC<ShowCounterProps> = ({ days, hours, minutes, seconds }) => {
  if (days && days > 0) {
    return (
      <>
        <DateTimeDisplay
          value={days.toString()}
          type={
            hours === 0 && days > 1
              ? ' Days'
              : hours === 0 && days === 1
                ? ' Day'
                : hours !== 0 && days > 1
                  ? ' Days : '
                  : ' Day : '
          }
        />
        {hours && hours > 0 && <DateTimeDisplay value={hours.toString()} type={hours === 1 ? ' Hour' : ' Hours'} />}
      </>
    )
  }

  return (
    <div>
      <DateTimeDisplay
        value={hours?.toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}
        type=" : "
      />
      <DateTimeDisplay
        value={(seconds && seconds > 0 ? (minutes || 0) + 1 : minutes || 0).toLocaleString('en-US', {
          minimumIntegerDigits: 2,
          useGrouping: false,
        })}
        type=""
      />
    </div>
  )
}

ShowCounter.propTypes = {
  days: PropTypes.number,
  hours: PropTypes.number,
  minutes: PropTypes.number,
  seconds: PropTypes.number,
}

ShowCounter.defaultProps = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
}

interface CountDownTimerProps {
  targetDate?: string
  timeZone?: string
}

const CountDownTimer: React.FC<CountDownTimerProps> = ({ targetDate, timeZone }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate || '', timeZone || '')

  useEffect(() => {
    if ((days || 0) + (hours || 0) + (minutes || 0) + (seconds || 0) <= 0) {
      setTimeout(() => window.location.reload(), 5000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minutes])

  if ((days || 0) + (hours || 0) + (minutes || 0) + (seconds || 0) <= 0) {
    return <div>Timer Expired, please refresh page.</div>
  }

  if ((days || 0) <= 7) {
    return <ShowCounter days={days} hours={hours} minutes={minutes} seconds={seconds} />
  }

  return <></>
}

CountDownTimer.propTypes = {
  targetDate: PropTypes.string,
  timeZone: PropTypes.string,
}

CountDownTimer.defaultProps = {
  targetDate: '',
  timeZone: '',
}

export default CountDownTimer
